import { render } from "./estadoCuenta.vue?vue&type=template&id=68339a57&scoped=true"
import script from "./estadoCuenta.vue?vue&type=script&lang=js"
export * from "./estadoCuenta.vue?vue&type=script&lang=js"

import "./estadoCuenta.vue?vue&type=style&index=0&id=68339a57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68339a57"]])

export default __exports__